/**
 * Builds the full category name path (root first) for a category placed under
 * `parentCategory`, ending with `leafName`. Used by the quick-create flow to
 * display "parent > child > baskets" right after a move, before the async
 * backend mapping (which would otherwise be the only source of the full path)
 * catches up.
 *
 * `parentCategory` is the chosen parent (a category object exposing its own
 * `parent` chain), or null/undefined when the category stays at the root.
 * `resolveName` extracts a category's translated name (injected so the helper
 * stays pure and testable, independent of the translation store).
 *
 * @param {?object} parentCategory
 * @param {string} leafName
 * @param {(category: object) => string} resolveName
 * @returns {string[]}
 */
export default function buildCategoryNamePath(parentCategory, leafName, resolveName) {
    const path = [];

    for (let node = parentCategory; node; node = node.parent) {
        path.unshift(resolveName(node));
    }

    path.push(leafName);

    return path;
}
